import React from 'react';
import Body from '../components/body/body';
import HeroSection from '../components/hero/heroSection';
import ProductSlider from '../components/products/productslider';

// import ProductSlider from '../components/products/slider';



const Homepage = () => {
    return (
        <>

            <HeroSection />

            <Body />
            <ProductSlider />



            {/* <ProductSlider /> */}




        </>
    );
}

export default Homepage;
